import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';
import { newCaso } from '../../actions';
import Steps from './newcaso/Steps';
import _ from 'lodash';
import CasoFormStep1 from './newcaso/CasoFormStep1';
import CasoFormStep2 from './newcaso/CasoFormStep2';
import CasoFormStep3 from './newcaso/CasoFormStep3';
import CasoFormStep4 from './newcaso/CasoFormStep4';
import CasoFormStep5 from './newcaso/CasoFormStep5';


class CasoForm extends Component {
    constructor(props) {
        super(props);
        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.state = {
            page: 1,
            steps: [
                {title: "Datos del caso", status: "active"},
                {title: "Objetivos", status: "disabled"},
                {title: "Planificación", status: "disabled"},
                {title: "Archivos adjuntos", status: "disabled"},
                {title: "Resumen", status: "disabled"}
            ]
        };
    }
    nextPage(values) {
        var self = this;
        let newSteps = this.state.steps.map(function (item, i) {
            let n = i + 1;
            if(n <= self.state.page){
                item.status = "complete";
            } else if(n === self.state.page+1){
                item.status = "active";
            }else{
                item.status = "disabled";
            }
            return item;
        });
        this.setState({
            page: this.state.page + 1,
            steps: newSteps,
            values: values
        });
    }

    previousPage() {
        var self = this;
        let newSteps = this.state.steps.map(function (item, i) {
            let n = i + 1;
            if(n >= self.state.page){
                item.status = "disabled";
            } else if(n === self.state.page-1){
                item.status = "active";
            }else{
                item.status = "complete";
            }
            return item;
        });
        this.setState({
            page: this.state.page - 1,
            steps: newSteps
        });
    }
    onSubmit(values){
        values.entrega = moment(values.entrega).format('YYYY-MM-DD HH:mm:ss')
        values.envio = moment(values.envio).format('YYYY-MM-DD HH:mm:ss')
        const cleanValues = _.pickBy(values, _.identity)
        console.log(cleanValues);

        var body = new FormData();
        if(this.props.match.params.id){
            body.append('client', this.props.match.params.id);
        }
        if(values.fotos && values.fotos.length > 0){
            values.fotos.forEach(function(file){
                body.append('photos[]', file);
            });
        }
        if(values.dicoms && values.dicoms.length > 0){
            values.dicoms.forEach(function(file){
                body.append('dicoms[]', file);
            });
        }
        if(values.radios && values.radios.length > 0){
            values.radios.forEach(function(file){
                body.append('radios[]', file);
            });
        }
        body.append('values', JSON.stringify(values));

        this.props.newCaso(body, this.props.client ? this.props.client.id : null);
    }
    render(){
        const { onSubmit } = this.props;

        const { handleSubmit } = this.props;

        const addresses = this.props.client && this.props.client.id ? this.props.client.addresses : this.props.addresses;

        return(
            <div className="justify-content-md-center">
                <div className="col-12 content-container form-container">
                    <Steps steps={this.state.steps} />
                    {{
                        1: (
                            <CasoFormStep1
                                addresses={addresses}
                                onSubmit={this.nextPage}
                                summary={this.state.values}
                                clientId={this.props.client ? this.props.client.id : null}
                            />
                        ),
                        2: (
                            <CasoFormStep2
                                previousPage={this.previousPage}
                                onSubmit={this.nextPage}
                                summary={this.state.values}
                            />
                        ),
                        3: (
                            <CasoFormStep3
                                previousPage={this.previousPage}
                                onSubmit={this.nextPage}
                                summary={this.state.values}
                            />
                        ),
                        4: (
                            <CasoFormStep4
                                previousPage={this.previousPage}
                                onSubmit={this.nextPage}
                                summary={this.state.values}
                            />
                        ),
                        5: (
                            <CasoFormStep5
                                previousPage={this.previousPage}
                                onSubmit={this.onSubmit.bind(this)}
                                summary={this.state.values}
                                addresses={addresses}
                            />
                        )

                    }[this.state.page]}
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    const stateProps = {
        addresses: state.user.addresses,
        client: state.client
    };
    if(state.client) stateProps.client = state.client;
    return stateProps;
}
export default connect(mapStateToProps, { newCaso })(CasoForm);


// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/CasoForm.jsx